import createSelector from "../../Utils/reselect";
import { DELIVERED_SERVICE_STATUS_OPTIONS } from "../../Constants/constant";
import { baseURLImage, getDifference, getNameProfile } from "../../Utils/utils";

const normalizeCategoryName = (name) =>
  (name || "").toString().trim().toLowerCase();

const ahStateData = (state) => {
  const { ah } = state;
  return ah || {};
};

export const updateCaseNotesSuccessSelector = createSelector(
  ahStateData,
  (ah) => ah.get("updateCaseNotesSuccess") || false
);

export const deleteCaseNoteSuccessSelector = createSelector(
  ahStateData,
  (ah) => ah.get("deleteCaseNoteSuccess") || false
);

export const updateCaseNotesLoadingSelector = createSelector(
  ahStateData,
  (ah) => ah.get("updateCaseNotesLoading") || false
);

export const getCaseNoteDetailLoader = createSelector(
  ahStateData,
  (ah) => ah.get("getCaseNoteDetailLoading") || false
);

export const getCaseNoteDataSelector = createSelector(
  ahStateData,
  (ah) => ah.get("getCaseNoteData") || []
);

export const getCosSettingCategoriesLoader = createSelector(
  ahStateData,
  (ah) => ah.get("cosSettingCategoriesLoader") || false
);

export const getCosSettingContactTypeLoader = createSelector(
  ahStateData,
  (ah) => ah.get("cosSettingContactTypeLoader") || false
);

export const getCosSettingPriorityLoader = createSelector(
  ahStateData,
  (ah) => ah.get("cosSettingPriorityLoader") || false
);

export const DynamicBreadCrumbSelector = createSelector(
  ahStateData,
  (ah) => ah.get("DynamicBreadCrumb") || []
);

export const createNewFolderSuccessSelector = createSelector(
  ahStateData,
  (ah) => ah.get("createNewFolderSuccess") || false
);

export const createNewFolderLoadingSelector = createSelector(
  ahStateData,
  (ah) => ah.get("createNewFolderLoading") || false
);

export const getRemoveFolder = createSelector(
  ahStateData,
  (ah) => ah.get("removeFolderSuccess") || ""
);

export const getRemoveFolderLoading = createSelector(
  ahStateData,
  (ah) => ah.get("createNewFolderLoading") || false
);

export const getRemoveFolderError = createSelector(
  ahStateData,
  (ah) => ah.get("removeFolderError") || ""
);

export const getFolderListForHRMLoadingSelector = createSelector(
  ahStateData,
  (ah) => ah.get("getFolderListForHRMLoading") || false
);

export const getFolderListForHRMSelector = createSelector(
  ahStateData,
  (ah) => {
    if (!ah || typeof ah.get !== "function") return [];
    const raw = ah.get("getFolderListForHRM");
    return raw || [];
  }
);

export const getFileListForHRMSelector = createSelector(
  ahStateData,
  (ah) => ah.get("getFileListForHRM") || []
);

export const updateCategorySuccessSelector = createSelector(
  ahStateData,
  (ah) => ah.get("updateCategorySuccess") || false
);

export const updatePrioritySuccessSelector = createSelector(
  ahStateData,
  (ah) => ah.get("updatePrioritySuccess") || false
);

export const updateContactSuccessSelector = createSelector(
  ahStateData,
  (ah) => ah.get("updateContactSuccess") || false
);

export const reportLoadingSelector = createSelector(
  ahStateData,
  (ah) => ah.get("reportLoading") || false
);

export const getCaseNotesErrorSelector = createSelector(
  ahStateData,
  (ah) => ah.get("caseNoteerror") || false
);

export const newPeriorityListSelector = createSelector(
  ahStateData,
  (ah) => ah.getIn(["cosInvoice", "newPeriorityList"]) || false
);

export const createNewContactSelector = createSelector(
  ahStateData,
  (ah) => ah.getIn(["cosInvoice", "createNewContact"]) || false
);

export const createNewCategorySelector = createSelector(
  ahStateData,
  (ah) => ah.getIn(["cosInvoice", "createNewCategory"]) || false
);

export const updateCategoryLoadingSelector = createSelector(
  ahStateData,
  (ah) => ah.get("updateCategoryLoading") || false
);

export const updateCategoryErrorSelector = createSelector(
  ahStateData,
  (ah) => ah.get("updateCategoryLoading") || ""
);

export const updateContactLoadingSelector = createSelector(
  ahStateData,
  (ah) => ah.get("updateContactLoading") || false
);

export const updateContactErrorSelector = createSelector(
  ahStateData,
  (ah) => ah.get("updateContactError") || ""
);

export const updatePriorityLoadingSelector = createSelector(
  ahStateData,
  (ah) => ah.get("updatePriorityLoading") || false
);

export const updatePriorityErrorSelector = createSelector(
  ahStateData,
  (ah) => ah.get("updatePriorityError") || ""
);

export const getDashboardDataLoadingSelector = createSelector(
  ahStateData,
  (ah) => ah.get("getDashboardDataLoading") || false
);

export const getDashboardDataSelector = createSelector(
  ahStateData,
  (ah) => ah.get("getDashboardData") || []
);

export const createNewContactLoadingSelector = createSelector(
  ahStateData,
  (ah) => ah.get("createNewContactLoading") || false
);

export const createNewContactErrorSelector = createSelector(
  ahStateData,
  (ah) => ah.get("createNewContactError") || ""
);

export const createNewPriorityLoadingSelector = createSelector(
  ahStateData,
  (ah) => ah.get("createNewPriorityLoading") || false
);

export const createNewPriorityErrorSelector = createSelector(
  ahStateData,
  (ah) => ah.get("createNewPriorityError") || ""
);

export const createNewCategoryLoadingSelector = createSelector(
  ahStateData,
  (ah) => ah.get("createNewCategoryLoading") || false
);

export const createNewCategoryErrorSelector = createSelector(
  ahStateData,
  (ah) => ah.get("createNewCategoryError") || ""
);

export const fundingsForCosLoadingSelector = createSelector(
  ahStateData,
  (ah) => ah.get("fundingsForCosLoading") || false
);

export const fundingsForCosSelector = createSelector(ahStateData, (ah) => {
  const data = ah.get("fundingsForCos") || [];
  const newData = data.map((item) => {
    const expired = Boolean(item.is_expired);
    const label = expired
      ? `${item.contract_id} (Expired)`
      : item.contract_id;
    return { ...item, label, value: item.uuid };
  });
  return newData;
});

export const clientTaskListLoadingSelector = createSelector(
  ahStateData,
  (ah) => ah.get("createclientTaskListLoading") || false
);

export const updateClientTaskResponseSelector = createSelector(
  ahStateData,
  (ah) => ah.get("updateClientTaskResponse") || []
);

export const tableDataOfCaseNotesForReportingLoadingSelector = createSelector(
  ahStateData,
  (ah) => ah.get("tableDataOfCaseNotesForReportingLoading") || false
);

export const getTableDataOfCaseNotesForReportingSelector = createSelector(
  ahStateData,
  (ah) => {
    const raw = ah.get("tableDataForReportingForCaseNotes");
    if (!raw) return [];
    if (raw.casenotes && Array.isArray(raw.casenotes.data)) return raw.casenotes.data;
    return Array.isArray(raw) ? raw : [];
  }
);

export const getTableDataOfCaseNotesForReportingPaginationMetaSelector = createSelector(
  ahStateData,
  (ah) => {
    const raw = ah.get("tableDataForReportingForCaseNotes");
    if (!raw || !raw.casenotes) return null;
    const c = raw.casenotes;
    if (typeof c.total === "undefined") return null;
    const perPage = c.per_page ?? 25;
    const total = c.total ?? 0;
    return {
      current_page: c.current_page ?? 1,
      last_page:
        c.last_page ??
        c.total_pages ??
        (total > 0 ? Math.ceil(total / perPage) : 1),
      per_page: perPage,
      total,
    };
  }
);

export const tableDataForReportingLoadingSelector = createSelector(
  ahStateData,
  (ah) => ah.get("tableDataForReportingLoading") || false
);

export const getTableDataForReportingSelector = createSelector(
  ahStateData,
  (ah) => ah.get("tableDataForReporting") || []
);

export const getClientTaskResponseSelector = createSelector(
  ahStateData,
  (ah) => ah.get("clientTaskResponse") || []
);

export const getContactListOPTSelector = createSelector(ahStateData, (ah) => {
  const data = ah.get("ContactList") || [];
  const newData = data.map((item) => {
    return { ...item, label: item.title, value: item.uuid };
  });
  return newData;
});

export const getCatogeryListSelector = createSelector(ahStateData, (ah) => {
  const data = ah.get("CatogeryList") || [];
  const newData = data.map((item) => {
    return { ...item, label: item.title, value: item.id };
  });
  return newData;
});

export const getPeriorityListSelector = createSelector(ahStateData, (ah) => {
  const data = ah.get("periorityList") || [];
  const newData = data.map((item) => {
    return {
      ...item,
      label: item.title,
      value: item.id,
    };
  });
  return newData;
});

export const getContactListSelector = createSelector(
  ahStateData,
  (ah) => ah.get("ContactList") || []
);

export const caseNotesCreateLoadingSelector = createSelector(
  ahStateData,
  (ah) => ah.get("caseNotesCreateLoading") || false
);

export const cerateCaseNotesSuccessDataSelector = createSelector(
  ahStateData,
  (ah) => ah.get("cerateCaseNotesSuccessData") || []
);

export const changeCaseNotesInvoiceStatusSuccessSelector = createSelector(
  ahStateData,
  (ah) =>
    ah.getIn(["cosInvoice", "changeCaseNotesInvoiceStatusSuccess"]) || false
);

export const changeNDISCaseNotesInvoiceStatusLoadingSelector = createSelector(
  ahStateData,
  (ah) =>
    ah.getIn(["cosInvoice", "changeNDISCaseNotesInvoiceStatusLoading"]) ||
    false
);

export const changeNDISCaseNotesStatusLoadingSelector = createSelector(
  ahStateData,
  (ah) =>
    ah.getIn(["cosInvoice", "changeNDISCaseNotesStatusLoading"]) || false
);

export const ndisClaimModeSelector = createSelector(
  ahStateData,
  (ah) => ah.get("ndisClaimMode") || "old"
);

// export const caseNoteReviewLoadingSelector = createSelector(
//   ahStateData,
//   (ah) => ah.get("caseNoteReviewLoading") || false
// );

export const createdCosInvoiceReviewLoadingSelector = createSelector(
  ahStateData,
  (ah) => ah.getIn(["cosInvoice", "createdCosInvoiceReviewLoading"]) || false
);

export const createdCosReviewInvoiceDeliveryStatusSelector = createSelector(
  ahStateData,
  (ah) => {
    const data =
      ah.getIn(["cosInvoice", "createdCosReviewInvoiceDeliveryStatus"]) || [];
    const newList = [];
    data.length > 0 &&
      data.forEach((e) => {
        const val = { value: e.status_key };
        newList.push(val);
      });
    const res = getDifference(DELIVERED_SERVICE_STATUS_OPTIONS, newList);
    return res || [];
  }
);

export const createdCosReviewInvoiceClientsSelector = createSelector(
  ahStateData,
  (ah) => {
    const data =
      ah.getIn(["cosInvoice", "createdCosReviewInvoiceClients"]) || [];
    const updatedList =
      data &&
      data.map((item) => {
        return {
          ...item,
          value: item.uuid,
          label: item.first_name.concat(" ", item.last_name),
        };
      });
    return updatedList;
  }
);

export const getAddCaseNotesToListLoader = createSelector(
  ahStateData,
  (ah) => ah.get("addCaseNotesToListLoading") || false
);

export const createdCosInvoicesReviewLoader = createSelector(
  ahStateData,
  (ah) => ah.getIn(["cosInvoice", "createdCosInvoiceRiviewLoading"]) || false
);

export const getCreatedCosInvoiceLoaderSelector = createSelector(
  ahStateData,
  (ah) => {
    const data = ah.getIn(["cosInvoice", "createdCosInvoiceLoading"]) || null;
    return data;
  }
);

export const getCreatedCosInvoiceReviewSelector = createSelector(
  ahStateData,
  (ah) => {
    const data = ah.getIn(["cosInvoice", "createdCosReviewInvoice"]) || null;
    return data;
  }
);

export const createdCosInvoicesLoader = createSelector(
  ahStateData,
  (ah) => ah.getIn(["cosInvoice", "createdCosInvoiceLoading"]) || false
);

export const getCreatedCosInvoiceSelector = createSelector(
  ahStateData,
  (ah) => {
    const data = ah.get("createdCosInvoice") || null;
    return data;
  }
);

export const createCosInvoicesLoader = createSelector(
  ahStateData,
  (ah) => ah.getIn(["cosInvoice", "createCosInvoiceLoading"]) || false
);

export const getcosInvoiceSelector = createSelector(
  ahStateData,
  (ah) => ah.getIn(["cosInvoice", "cosInvoiceList"]) || null
);
// .setIn(["cosInvoice", "createCosInvoiceLoading"], false)

export const getCOSInvoiceLoaderSelector = createSelector(
  ahStateData,
  (ah) => ah.getIn(["cosInvoice", "cosInvoiceLoading"]) || false
);

export const getCaseNoteReviewLoadingSelector = createSelector(
  ahStateData,
  (ah) => ah.get("caseNoteReviewLoading") || false
);

// export const getCOSInvoiceLoaderSelector = createSelector(
//   ahStateData,
//   (ah) => ah.getIn(["COSInvoice", "fetchNdisClaimsCaseNotesLoader"]) || false
// );
export const getCaseNotesCreateLoadingSelector = createSelector(
  ahStateData,
  (ah) => ah.get("caseNotesCreateLoading") || false
);

export const changeStatusSuccessSelector = createSelector(
  ahStateData,
  (ah) => ah.get("changeStatusSuccess") || null
);

export const getCaseNoteReviewSelector = createSelector(
  ahStateData,
  (ah) => ah.get("caseNoteReview") || null
);

export const getClaimedCaseNotesListLoadingSelector = createSelector(
  ahStateData,
  (ah) => ah.get("claimedCaseNotesListLoading") || null
);

export const getStatusFromNdisListSelector = createSelector(
  ahStateData,
  (ah) => {
    const data = ah.get("statusList") || [];

    const newList = [];
    data &&
      data.length > 0 &&
      data.forEach((e) => {
        const val = { value: e.status_key };
        newList.push(val);
      });
    const res = getDifference(DELIVERED_SERVICE_STATUS_OPTIONS, newList);
    return res || [];
  }
);

export const getSelectedClientsListSelector = createSelector(
  ahStateData,
  (ah) => {
    const data = ah.get("selectedClientList") || null;
    const updatedList =
      data &&
      data.map((item) => {
        return {
          ...item,
          value: item.id,
          label: item.first_name.concat(" ", item.last_name),
        };
      });
    return updatedList;
  }
);

export const getClaimedCaseNotesListSelector = createSelector(
  ahStateData,
  (ah) => {
    const data = ah.get("claimedCaseNotesList") || null;
    return data;
  }
);

export const getCaseNotesListForClaimLoaderSelector = createSelector(
  ahStateData,
  (ah) => ah.getIn(["ndisClaims", "fetchNdisClaimsCaseNotesLoader"]) || false
);

export const getCaseNotesListForClaimSelector = createSelector(
  ahStateData,
  (ah) => ah.getIn(["ndisClaims", "NdisClaimsCaseNotes"]) || null
);

export const getCaseNotesHistoryListLoaderSelector = createSelector(
  ahStateData,
  (ah) => ah.get("caseNotesHistoryLoading") || null
);

export const getCaseNotesHistoryListSelector = createSelector(
  ahStateData,
  (ah) => {
    const list = ah.get("caseNotesHistoryList");
    if (!list) return [];
    return Array.isArray(list) ? list : (list.data || []);
  }
);

export const getCaseNotesHistoryPaginationMetaSelector = createSelector(
  ahStateData,
  (ah) => {
    const list = ah.get("caseNotesHistoryList");
    if (!list || Array.isArray(list)) return null;
    if (list.meta) return list.meta;
    if (
      typeof list.current_page === "number" &&
      typeof list.total !== "undefined"
    ) {
      return {
        current_page: list.current_page,
        last_page: list.last_page ?? list.total_pages ?? list.current_page,
        per_page: list.per_page ?? 15,
        total: list.total,
        from: list.from,
        to: list.to,
      };
    }
    return null;
  }
);

export const getClienListSelector = createSelector(ahStateData, (ah) => {
  const data = ah.getIn(["ndisClaims", "clientsList"]) || null;
  if (data && data.length > 0) {
    const NewDat = data.map((item) => {
      return {
        ...item,
        label: item?.first_name.concat(" ", item?.last_name),
        value: item?.uuid,
      };
    });
    // NewDat.unshift({ label: "all", value: "all" });
    return NewDat;
  }
});

export const getClienListLoaderSelector = createSelector(
  ahStateData,
  (ah) =>
    ah.getIn(["ndisClaims", "fetchNdisClaimCaseNoteClientsLoader"]) || false
);
export const getServiceSupportDropDownOptions = createSelector(
  ahStateData,
  (ah) => {
    const List = ah.get("serviceSupportItemsCaseNotes") || [];
    const myData = List.map((item) => {
      return {
        ...item,
        value: item?.uuid,
        label: item?.price_catalog?.support_item_name,
      };
    });
    return myData;
  }
);

export const getServiceSupportItemsCaseNotes = createSelector(
  ahStateData,
  (ah) => {
    const List = ah.get("serviceSupportItemsCaseNotes") || [];
    const myData = List.map((item) => {
      return {
        ...item,
        value: item?.id,
        label: item?.price_catalog?.support_item_number.concat(
          " ",
          item?.price_catalog?.support_item_name
        ),
      };
    });

    return myData;
  }
);

export const getSingleSupportTrackLoadingSelector = createSelector(
  ahStateData,
  (ah) => ah.get("singleSupportTrackLoading") || null
);

export const getSingleSupportTract = createSelector(
  ahStateData,
  (ah) => ah.get("singleSupportTract") || null
);

export const getFundingListData = createSelector(
  ahStateData,
  (ah) => ah.get("fundingList") || null
);
export const getFundingTableLoading = createSelector(
  ahStateData,
  (ah) => ah.get("fundingTableLoading") || false
);
export const getSupportTractList = createSelector(ahStateData, (ah) => {
  const List = ah.get("supportTractList") || [];
  const newData = List.map((item) => {
    return {
      ...item,
      value: item?.uuid,
      label: item?.delivered_service_number,
    };
  });
  return newData;
});

export const getReportDataSelector = createSelector(
  ahStateData,
  (ah) => ah.get("reportData") || null
);
export const getCliesntTaskList = createSelector(
  ahStateData,
  (ah) => ah.get("clientTaskList") || null
);

export const getCliesntTaskListLoading = createSelector(
  ahStateData,
  (ah) => ah.get("clientTaskListLoading") || null
);
export const getAllCatalogServices = createSelector(
  ahStateData,
  (ah) => ah.get("catalog_services") || null
);

export const getCosCaseNoteList = createSelector(
  ahStateData,
  (ah) => ah.get("casNotesList") || null
);
export const getCosCaseNoteListLoading = createSelector(
  ahStateData,
  (ah) => ah.get("casNotesListLoading") || null
);

export const getParticipantsProfile = createSelector(
  ahStateData,
  (ah) => ah.get("cosParticipantsProfile") || null
);

export const getCatalogVersions = createSelector(ahStateData, (ah) => {
  const catalog_versions = ah.get("catalog_versions") || [];
  if (catalog_versions.length > 0) {
    return catalog_versions.map((x) => {
      const obj = {
        label: x.title,
        value: x.id,
      };
      return obj;
    });
  }
  return catalog_versions;
});

export const getAllCatalogServicesSubCategory = createSelector(
  ahStateData,
  (ah) => {
    const data = ah.get("catalog_sub_category") || [];
    return data?.map((x) => ({
      ...x,
      value: x.id,
      label: x.name?.toUpperCase(),
    }));
  }
);

export const getCatalogSubCategoryStatesLoading = createSelector(
  ahStateData,
  (ah) => ah.get("catalog_sub_category_loading") || false
);

export const getServiceCatalogStates = createSelector(ahStateData, (ah) => {
  const states = ah.get("catalog_sub_category") || null;
  if (states) {
    return states.map((x) => {
      const obj = {
        value: x.id,
        label: x.name.toUpperCase(),
      };
      return obj;
    });
  }
  return states;
});
export const getcatalogServicesLoadingLoader = createSelector(
  ahStateData,
  (ah) => ah.get("catalogServicesLoading") || false
);

export const getCOSLoader = createSelector(
  ahStateData,
  (ah) => ah.get("loading") || false
);

export const getStoreFundingSetupLoading = createSelector(
  ahStateData,
  (ah) =>
    ah.getIn(["participantFunding", "storeFundingSetupLoading"]) || false
);

export const getFundingManagementImpactCheck = createSelector(
  ahStateData,
  (ah) => {
    const val = ah.getIn(["participantFunding", "fundingManagementImpactCheck"]);
    return val && typeof val.toJS === "function" ? val.toJS() : val;
  }
);

export const getStoreFundingSetupError = createSelector(
  ahStateData,
  (ah) => ah.getIn(["participantFunding", "storeFundingSetupError"]) || ""
);

export const getParticipantFundingsList = createSelector(
  ahStateData,

  (ah) => {
    const List = ah.getIn(["participantFunding", "fundings"]) || null;
    let MyData = [];
    MyData = List?.data?.map((item) => {
      return { ...item, label: item?.contract_id, value: item?.uuid };
    });
    return MyData;
  }
);

export const getParticipantFundings = createSelector(
  ahStateData,
  (ah) => ah.getIn(["participantFunding", "fundings"]) || null
);

export const getParticipantFundingsLoading = createSelector(
  ahStateData,
  (ah) => ah.getIn(["participantFunding", "fundingsLoading"]) || false
);

export const getDeleteFundingLoading = createSelector(
  ahStateData,
  (ah) => ah.getIn(["participantFunding", "deleteFundingLoading"]) || false
);

export const getSelectedFundingLoading = createSelector(
  ahStateData,
  (ah) => ah.getIn(["participantFunding", "selectedFundingLoading"]) || false
);

export const getSelectedFunding = createSelector(ahStateData, (ah) => {
  const funding = ah.getIn(["participantFunding", "selectedFunding"]) || null;
  const parseInJson = (data) => {
    if (data) {
      if (typeof data === "string") {
        Object.assign(funding, {
          funding_management: JSON.parse(data),
        });
        return typeof JSON.parse(data);
      } else {
        Object.assign(funding, {
          funding_management: data,
        });
        return typeof data;
      }
    }
    return null;
  };

  if (funding) {
    do {
      parseInJson(funding.funding_management);
    } while (parseInJson(funding.funding_management) === "string");
  }

  return funding;
});

export const getCreatePlanBudgetLoader = createSelector(
  ahStateData,
  (ah) => ah.getIn(["participantFunding", "createPlanBudgetLoader"]) || false
);

export const getCreateServiceCategoryBudgetLoader = createSelector(
  ahStateData,
  (ah) =>
    ah.getIn(["participantFunding", "createServiceCategoryBudgetLoader"]) ||
    false
);

export const getCreatePlanBudgetError = createSelector(
  ahStateData,
  (ah) => ah.getIn(["participantFunding", "createPlanBudgetError"]) || ""
);

export const getPlanBudgets = createSelector(
  ahStateData,
  (ah) => ah.getIn(["participantFunding", "planBudgetFunding"]) || null
);

export const getFetchPlanBudgetLoader = createSelector(
  ahStateData,
  (ah) => ah.getIn(["participantFunding", "fetchPlanBudgetLoader"]) || false
);

export const getFetchServiceCategoryLoader = createSelector(
  ahStateData,
  (ah) =>
    ah.getIn(["participantFunding", "serviceCategoryPlanBudgetFetchLoader"]) ||
    false
);

export const getRemovePlanBudgetLoader = createSelector(
  ahStateData,
  (ah) => ah.getIn(["participantFunding", "removePlanBudgetLoader"]) || false
);

export const getRemoveServiceCategoryLoader = createSelector(
  ahStateData,
  (ah) =>
    ah.getIn(["participantFunding", "removeServiceCategoryLoader"]) || false
);

export const getPlanCatagories = createSelector(ahStateData, (ah) => {
  const planCatagories = ah.get("planCatagories");
  if (planCatagories) {
    const subCatagories = {};
    const catagory = planCatagories
      .map((x) => {
        const normalizedName = normalizeCategoryName(x.name);
        const obj = {
          value: x.id,
          label: x.name,
        };
        if (normalizedName === "core") {
          Object.assign(obj, { sequence: 1 });
        } else if (normalizedName === "capacity building") {
          Object.assign(obj, { sequence: 2 });
        } else {
          Object.assign(obj, { sequence: 3 });
        }
        Object.assign(subCatagories, {
          [x.name.replace(" ", "_")]: x.service_sub_categories.map((x) => {
            const obj = { value: x.id, label: x.title };
            return obj;
          }),
        });
        return obj;
      })
      .sort((a, b) => (a.sequence < b.sequence ? -1 : 1));
    return {
      catagory,
      subCatagories,
    };
  }
  return null;
});

export const getServiceCatalogBudgetPlanCatAndSubCatOptions = createSelector(
  ahStateData,
  (ah) => {
    const planCatAndSubCat =
      ah.getIn(["participantFunding", "planBudgetCatAndSubCat"]) || {};
    if (
      Object.keys(planCatAndSubCat).length > 0 &&
      planCatAndSubCat.hasOwnProperty("service_cat")
    ) {
      const planBudgetCategories = [];
      const planBudgetSubCategories = {};

      planCatAndSubCat.service_cat.forEach((x) => {
        planBudgetCategories.push({
          created_at: x.created_at,
          id: x.id,
          name: x.name,
          updated_at: x.updated_at,
          uuid: x.uuid,
          label: x.name,
          value: x.id,
        });
        Object.assign(planBudgetSubCategories, {
          [x.name.replace(" ", "_")]: x.service_sub_categories.map((y) => {
            return { ...y, value: y.id, label: y.title };
          }),
        });
      });
      const sequencePlanCat = planBudgetCategories
        .map((x) => {
          const normalizedName = normalizeCategoryName(x.name);
          const obj = x;
          if (normalizedName === "core") {
            Object.assign(obj, { sequence: 1 });
          } else if (normalizedName === "capacity building") {
            Object.assign(obj, { sequence: 2 });
          } else {
            Object.assign(obj, { sequence: 3 });
          }
          return obj;
        })
        .sort((a, b) => (a.sequence < b.sequence ? -1 : 1));
      return { planBudgetCategories: sequencePlanCat, planBudgetSubCategories };
    }
    return null;
  }
);

export const getExternalServiceProviders = createSelector(
  ahStateData,
  (ah) => {
    const planCatAndSubCat =
      ah.getIn(["participantFunding", "planBudgetCatAndSubCat"]) || {};
    if (
      Object.keys(planCatAndSubCat).length > 0 &&
      planCatAndSubCat.hasOwnProperty("external_sps")
    ) {
      const data = planCatAndSubCat.external_sps.map((x) => {
        return { ...x, value: x.id, label: x.name };
      });
      data.unshift({
        value: "add_service_provider",
        label: "Add New Service Provider",
      });
      return [...data];
    }
    return [];
  }
);

export const getStoreServiceCategoryPlanBudgetLoader = createSelector(
  ahStateData,
  (ah) =>
    ah.getIn(["participantFunding", "serviceCategoryPlanBudgetLoader"]) ||
    false
);

export const getStoreServiceCategoryPlanBudgetError = createSelector(
  ahStateData,
  (ah) =>
    ah.getIn(["participantFunding", "serviceCategoryPlanBudgetError"]) || ""
);

export const getServiceCategoryPlanBudget = createSelector(
  ahStateData,
  (ah) =>
    ah.getIn(["participantFunding", "serviceCategoryPlanBudget"]) || null
);

export const getExternalSPLists = createSelector(
  ahStateData,
  (ah) => ah.get("externalSpList") || null
);

export const getExternalSPCreateLoader = createSelector(
  ahStateData,
  (ah) => ah.get("externalSpCreateLoader") || false
);

export const getExternalSPCreateError = createSelector(
  ahStateData,
  (ah) => ah.get("externalSpCreateError") || ""
);

export const getExternalSP = createSelector(
  ahStateData,
  (ah) => ah.getIn(["participantFunding", "external_sp"]) || null
);

export const getFundingNotes = createSelector(
  ahStateData,
  (ah) => ah.getIn(["participantFunding", "fundingNotes"]) || null
);

export const getFetchFundingNotesLoader = createSelector(
  ahStateData,
  (ah) => ah.getIn(["participantFunding", "fetchFundingNotesLoader"]) || false
);

export const getCreateFundingNotesLoader = createSelector(
  ahStateData,
  (ah) =>
    ah.getIn(["participantFunding", "createFundingNotesLoader"]) || false
);

export const getCreateFundingNotesError = createSelector(
  ahStateData,
  (ah) => ah.getIn(["participantFunding", "createFundingListError"]) || ""
);

export const getRemoveFundingNotesLoader = createSelector(
  ahStateData,
  (ah) =>
    ah.getIn(["participantFunding", "removeFundingNotesLoader"]) || false
);

export const getCreateServiceSupportLoader = createSelector(
  ahStateData,
  (ah) =>
    ah.getIn(["participantFunding", "createServiceSupportLoader"]) || false
);

export const getCreateServiceSupportError = createSelector(
  ahStateData,
  (ah) => ah.getIn(["participantFunding", "createServiceSupportError"]) || ""
);

export const getServiceSupportBudget = createSelector(
  ahStateData,
  (ah) => ah.getIn(["participantFunding", "serviceSupportBudget"]) || null
);

export const getServiceSupportBudgetFetchLoader = createSelector(
  ahStateData,
  (ah) =>
    ah.getIn(["participantFunding", "fetchServiceSupportLoader"]) || false
);

// export const getCaseNoteServiceSupportItems = createSelector(
//   ahStateData,
//   (ah) => {
//     const items =
//       ah.getIn(["participantFunding", "serviceSupportItems"]) || null;
//     if (items) {
//       return items.map((x) => {
//         return {
//           label: x.price_catalog.support_item_number,
//           value: x.id,
//         };
//       });
//     }
//     return items;
//   }
// );

export const getServiceSupportItems = createSelector(ahStateData, (ah) => {
  const items =
    ah.getIn(["participantFunding", "serviceSupportItems"]) || null;
  if (items) {
    return items.map((x) => {
      return {
        ...x,
        label: `${x.price_catalog.support_item_number} ${x.price_catalog.support_item_name}`,
        value: x.id,
      };
    });
  }
  return items;
});
export const getCosParticipantLoader = createSelector(
  ahStateData,
  (ah) =>
    ah.getIn(["participantFunding", "fetchCosParticipantLoader"]) || false
);

export const getCosParticipant = createSelector(
  ahStateData,
  (ah) => ah.getIn(["participantFunding", "cosParticipant"]) || null
);

export const getSupportCoordinator = createSelector(ahStateData, (ah) => {
  const data = ah.getIn(["participantFunding", "supportCoordinator"]) || [];
  const newData =
    data &&
    data.map((item) => {
      return {
        ...item,
        label: `${item?.first_name} ${item?.last_name}`,
        value: item?.uuid,
        icon: item.photo
          ? baseURLImage(item.photo)
          : getNameProfile(item.first_name, item.last_name || " "),
      };
    });
  return newData;
});

export const getSupportCoordinatorLoader = createSelector(
  ahStateData,
  (ah) =>
    ah.getIn(["participantFunding", "supportCoordinatorLoader"]) || false
);

export const getDeliveredServiceStoreLoader = createSelector(
  ahStateData,
  (ah) =>
    ah.getIn(["participantFunding", "deliveredServiceStoreLoader"]) || false
);

export const getDeliveredServiceStoreError = createSelector(
  ahStateData,
  (ah) => ah.getIn(["participantFunding", "deliveredServiceStoreError"]) || ""
);

export const grtServiceSupportItemsForDeliveredLoading = createSelector(
  ahStateData,
  (ah) =>
    ah.getIn([
      "participantFunding",
      "fetchServiceSupportItemsForDeliveredLoader",
    ]) || false
);

export const getManualDeliveredServiceStoreLoader = createSelector(
  ahStateData,
  (ah) =>
    ah.getIn(["participantFunding", "manualDeliveredServiceStoreLoader"]) ||
    false
);

export const getManualDeliveredServiceStoreError = createSelector(
  ahStateData,
  (ah) =>
    ah.getIn(["participantFunding", "manualDeliveredServiceStoreError"]) || ""
);

export const getDeliveredServiceFetchLoader = createSelector(
  ahStateData,
  (ah) =>
    ah.getIn(["participantFunding", "fetchDeliveredServiceLoader"]) || false
);

export const getManualDeliveriesFetchLoader = createSelector(
  ahStateData,
  (ah) =>
    ah.getIn(["participantFunding", "fetchManualDeliveriesLoader"]) || false
);

export const getDeliveredServices = createSelector(
  ahStateData,
  (ah) => ah.getIn(["participantFunding", "deliveredServices"]) || null
);

export const getManualDeliveries = createSelector(
  ahStateData,
  (ah) => ah.getIn(["participantFunding", "manualDeliveries"]) || null
);

export const getCosCategorySetting = createSelector(
  ahStateData,
  (ah) => ah.get("cos_category_setting") || []
);

export const getCosContactSetting = createSelector(
  ahStateData,
  (ah) => ah.get("cos_contact_setting") || []
);

export const getCosPrioritySetting = createSelector(
  ahStateData,
  (ah) => ah.get("cos_priority_setting") || []
);
